export enum Role {
    Super = 'Super',
    Manager = 'Manager',
    AltrixAdmin = 'Altrix Admin',
    Facility = 'Facility',
    Nurse = 'Nurse',    
    Locked = 'Locked',
    Employee = 'Employee',
    Reporting = 'Reporting'
}